














import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'

@Component({
  components: {}
})
export default class ActionDialog extends Mixins(BaseVue) {
  @Prop({ default: false })
  public show!: boolean

  @Prop({ default: '' })
  public title!: string

  @Prop({ default: '' })
  public message!: string

  private updateShow(newValue: boolean) {
    this.$emit('update:show', newValue)
  }

  private cancel(): void {
    this.updateShow(false)
    this.$emit('cancel')
  }

  private ok(): void {
    this.updateShow(false)
    this.$emit('ok')
  }
}
